module.exports = __webpack_public_path__ + "img/logo.9df7d5cd.svg";